
export const Inputs = [
    [

        {
            type: "password",
            label: { ar: "", en: "" },
            placeholder: { ar: "كلمة المرور", en: "Password" },
            title: { ar: "كلمة المرور", en: "Password" },
            name: "password",
            size: { lg: "6", md: "6" }
        },
        {
            type: "password",
            label: { ar: "", en: "" },
            placeholder: { ar: "تأكيد كلمة المرور", en: "Password confirmation" },
            title: { ar: "تأكيد كلمة المرور", en: "Password confirmation" },
            name: "confirmpassword",
            size: { lg: "6", md: "6" }
        },
       
       
    ]

];

